import { RouteRecordRaw } from "vue-router";

const routes: RouteRecordRaw[] = [
  {
    path: "markup",
    component: () => import("../pages/DatasetMarkup.vue"),
  },
  {
    path: "synthesis",
    component: () => import("../pages/DatasetSynthesis.vue"),
  },
  {
    path: "control",
    component: () => import("../pages/DatasetControl.vue"),
  },
  {
    path: "audio",
    component: () => import("../pages/DatasetAudio.vue"),
  },
  {
    path: "v2/text",
    component: () => import("../pages/DatasetV2Texts.vue"),
  },
  {
    path: "v2/image",
    component: () => import("../pages/DatasetV2Images.vue"),
  },
  {
    path: "v3/text",
    component: () => import("../pages/DatasetV3Texts.vue"),
  },
  {
    path: "v3/template",
    component: () => import("../pages/DatasetV3TemplatesV2.vue"),
  },
  {
    path: "v4",
    component: () => import("../pages/DatasetV4.vue"),
    children: [
      {
        path: "",
        redirect: { name: "dataset_v4_view" },
      },
      {
        path: "view",
        name: "dataset_v4_view",
        component: () =>
          import("../components/v4/dataset-view/dataset-view.vue"),
      },
      {
        path: "markup/fast",
        name: "dataset_markup_fast",
        component: () =>
          import(
            "../components/v4/dataset-markups/dataset-markup-fast/dataset-markup-fast.vue"
          ),
      },
    ],
  },
];

export default routes;
